<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
        <app-toolbar [toolbar]="toolbar">
            <ng-template 
              toolbarToolDef="confirm" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_confirm_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
            <ng-template 
              toolbarToolDef="cancel" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_cancel_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
        </app-toolbar>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-header"
                     *ngIf="!fieldsets.header.hidden && !fieldsets.header.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.header.collapsible }">
                    <div *ngIf="!fieldsets.header.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.header.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.header.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.header.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.header.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.header.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.header.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-weight_variance_threshold_percent" *ngIf="!fields.weight_variance_threshold_percent.hidden && !fields.weight_variance_threshold_percent.removed" 
                            class="field-container standard {{fields.weight_variance_threshold_percent.invalid ? 'invalid' : ''}} {{fields.weight_variance_threshold_percent.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.weight_variance_threshold_percent.styles.style"
                            [ngClass]="fields.weight_variance_threshold_percent.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.weight_variance_threshold_percent.label + (fields.weight_variance_threshold_percent.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.weight_variance_threshold_percent.label}}<span *ngIf="fields.weight_variance_threshold_percent.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="weight_variance_threshold_percent"
                                matInput
                                numberBox
                                [format]="fields.weight_variance_threshold_percent.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.weight_variance_threshold_percent.control.readOnly || fields.weight_variance_threshold_percent.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.weight_variance_threshold_percent.control.placeholder}}"
                                [ngStyle]="fields.weight_variance_threshold_percent.control.styles.style"
                                [ngClass]="fields.weight_variance_threshold_percent.control.styles.classes"
                                [matTooltip]="fields.weight_variance_threshold_percent.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.weight_variance_threshold_percent.invalid">
                          <ng-container *ngFor="let error of fields.weight_variance_threshold_percent.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-require_container_type" *ngIf="!fields.require_container_type.hidden && !fields.require_container_type.removed" 
                            class="field-container full {{fields.require_container_type.invalid ? 'invalid' : ''}} {{fields.require_container_type.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.require_container_type.styles.style"
                            [ngClass]="fields.require_container_type.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.require_container_type.label + (fields.require_container_type.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.require_container_type.label}}<span *ngIf="fields.require_container_type.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="require_container_type"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.require_container_type.control.styles.style"
                                      [ngClass]="fields.require_container_type.control.styles.classes"
                                      [matTooltip]="fields.require_container_type.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.require_container_type.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.require_container_type.invalid">
                          <ng-container *ngFor="let error of fields.require_container_type.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-require_complete_all_instructions" *ngIf="!fields.require_complete_all_instructions.hidden && !fields.require_complete_all_instructions.removed" 
                            class="field-container full {{fields.require_complete_all_instructions.invalid ? 'invalid' : ''}} {{fields.require_complete_all_instructions.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.require_complete_all_instructions.styles.style"
                            [ngClass]="fields.require_complete_all_instructions.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.require_complete_all_instructions.label + (fields.require_complete_all_instructions.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.require_complete_all_instructions.label}}<span *ngIf="fields.require_complete_all_instructions.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="require_complete_all_instructions"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.require_complete_all_instructions.control.styles.style"
                                      [ngClass]="fields.require_complete_all_instructions.control.styles.classes"
                                      [matTooltip]="fields.require_complete_all_instructions.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.require_complete_all_instructions.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.require_complete_all_instructions.invalid">
                          <ng-container *ngFor="let error of fields.require_complete_all_instructions.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-can_continue_closed_sessions" *ngIf="!fields.can_continue_closed_sessions.hidden && !fields.can_continue_closed_sessions.removed" 
                            class="field-container full {{fields.can_continue_closed_sessions.invalid ? 'invalid' : ''}} {{fields.can_continue_closed_sessions.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.can_continue_closed_sessions.styles.style"
                            [ngClass]="fields.can_continue_closed_sessions.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.can_continue_closed_sessions.label + (fields.can_continue_closed_sessions.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.can_continue_closed_sessions.label}}<span *ngIf="fields.can_continue_closed_sessions.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="can_continue_closed_sessions"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.can_continue_closed_sessions.control.styles.style"
                                      [ngClass]="fields.can_continue_closed_sessions.control.styles.classes"
                                      [matTooltip]="fields.can_continue_closed_sessions.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.can_continue_closed_sessions.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.can_continue_closed_sessions.invalid">
                          <ng-container *ngFor="let error of fields.can_continue_closed_sessions.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-auto_print_reports_on_complete" *ngIf="!fields.auto_print_reports_on_complete.hidden && !fields.auto_print_reports_on_complete.removed" 
                            class="field-container full {{fields.auto_print_reports_on_complete.invalid ? 'invalid' : ''}} {{fields.auto_print_reports_on_complete.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.auto_print_reports_on_complete.styles.style"
                            [ngClass]="fields.auto_print_reports_on_complete.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.auto_print_reports_on_complete.label + (fields.auto_print_reports_on_complete.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.auto_print_reports_on_complete.label}}<span *ngIf="fields.auto_print_reports_on_complete.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="auto_print_reports_on_complete"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.auto_print_reports_on_complete.control.styles.style"
                                      [ngClass]="fields.auto_print_reports_on_complete.control.styles.classes"
                                      [matTooltip]="fields.auto_print_reports_on_complete.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.auto_print_reports_on_complete.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.auto_print_reports_on_complete.invalid">
                          <ng-container *ngFor="let error of fields.auto_print_reports_on_complete.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.header.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>